export const ORIGIN_ANYONE = 'Anyone'
export const ORIGIN_ME = 'Me'
export const ORIGIN_OTHERS = 'Others'
export const SORT_BY_DATE = 'Date'
export const SORT_BY_FIRST_NAME = 'First Name'
export const SORT_BY_LAST_NAME = 'Last Name'
export const SORT_ASC = 'ASC'
export const SORT_DESC = 'DESC'

// Pagination constants
export const DEFAULT_PERMISSION_EVENTS_PAGE_SIZE = 10
